import React, { useState,useEffect } from "react";
import { useLocation } from "react-router-dom";
import Head from "../header/Head"; 
import Navigation from "../header/Navigation";

function Header() {

  const [menuStatus, setMenuStatus] = useState(false);
  const location = useLocation(); // Get the current location
  const handleClick = () => {
     setMenuStatus(menuStatus => !menuStatus)
  }
  useEffect(() => {
    // Close the menu whenever the route changes
    setMenuStatus(false);
  }, [location]);
  return (

<div>
    <Head menuClick={handleClick}/>
    <Navigation active={menuStatus} menuClick={handleClick}/>
</div>
    );
}

export default Header;
